import type { CourseCalendarTime } from "@shared/models/course"
import moment from "moment"

export function formatCourseTimePart(startOrEnd: number): string {
  const partM = moment().utc().startOf("day").add(startOrEnd, "minutes")
  return partM.format("h:mma")
}

/**
 * @param start When parsing end, you may supply the existing start, to enforce
 * start <= end and reasonable AM/PM guesses.
 * @returns Parsed time part, or null if invalid
 */
export function parseCourseTimePart(startOrEndInputStr: string, start?: number): number | null {
  const partM = moment.utc(startOrEndInputStr.trim(), ["LT"])
  if (!partM.isValid()) return null

  let timePart = 60 * partM.hours() + partM.minutes()

  // Try to guess if the user implicitly wants PM.
  const explicitlyAM = startOrEndInputStr.toLowerCase().includes("a")
  if (!explicitlyAM && timePart < 12 * 60) {
    if (timePart < 6 * 60 || (start !== undefined && start > timePart)) {
      timePart += 12 * 60
    }
  }

  // Enforce start <= timePart.
  if (start !== undefined && start > timePart) timePart = start

  return timePart
}

export function formatCourseTime(time: CourseCalendarTime | null): string {
  if (time === null) return ""
  return `${formatCourseTimePart(time.start)} - ${formatCourseTimePart(time.end)}`
}

export function addCourseTimeParts(timePart: number, deltaMinutes: number): number {
  const dayLength = 24 * 60
  // Positive modulus (range [0, dayLength))
  return (((timePart + deltaMinutes) % dayLength) + dayLength) % dayLength
}
